import * as core from '../../../../../../../core'

import { query } from './save-change-impact.query'

export const RESOURCE = {
  payload: {
    alias: 'save.change.impact',
    description:
      'Creates or updates a change impact from the change impact modals',
    name: 'Save Change Impact',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
